// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__mVvOv","pagination__container":"Pagination_pagination__container__kJECb","active":"Pagination_active__q3h4d","item":"Pagination_item__+B4I+"};